/**************************************************
 * Nombre:       Tarjeta_Pregunta
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";

const Tarjeta_Pregunta = ({item, index, click}) => {
    const [img, setImg] = useState('');

    useEffect(() => {
        if (typeof item.img === 'object') {
            setImg(URL.createObjectURL(item.img))
        } else if (item.img !== undefined) {
            console.log(item.img)
            setImg(item.img)
        }
    }, [item])
    return (
        <Grid
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1, borderBottom: 1}}

        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 14, fontWeight: 600}}>{item.pregunta}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 12}}>{item.respuesta}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Pregunta